<template>
    <vx-modal v-model:visible="visible" size="sm" padding="standard">
        <template v-slot:header>
            New API Auth
        </template>
        <template v-slot:subheader>
            Choose the type of auth you need.
        </template>

        <vx-radio-selection v-model="authConfigType">
            <vx-radio-selection-item value="custom_header">Custom Headers</vx-radio-selection-item>
            <vx-radio-selection-item value="oauth2_client_credentials">OAuth Client Credentials</vx-radio-selection-item>
        </vx-radio-selection>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button
                    @click="visible = false"
                    type="button"
                    class="grow lg:w-20 lg:grow-0"
                    size="lg"
                    color="muted"
                >
                    Cancel
                </vx-button>
                <vx-button
                    data-test="submit"
                    @click="submit()"
                    class="grow"
                    size="lg"
                    color="primary"
                >
                    Continue <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxModal, VxButton, VxRadioSelection, VxRadioSelectionItem } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { ref } from 'vue';

const visible = defineModel('visible', {
    type: Boolean,
    default: false,
});

const authConfigType = ref('custom_header');

const emit = defineEmits(['continue']);

const submit = () => {
    emit('continue', authConfigType.value);
    visible.value = false;
    authConfigType.value = 'custom_header';
}
</script>
